{% block sw_cms_block_acris_faq %}
    <div class="sw-cms-block-acris-faq">
        <slot name="column"></slot>
    </div>
{% endblock %}
